import { API } from "../auth/authApi";

API.interceptors.request.use((req) => {
  const token = localStorage.getItem("token");

  if (token) {
    req.headers.Authorization = `Bearer ${token}`;
  }

  return req;
});

/* SPEAKER APIs */

export const getSpeakersApi = (params) => {
  return API.get("/user/speakers", { params });
};

export const assignLocationApi = (data) => {
  return API.post("/user/assign-location", data);
};

export const addUpdateSponsorQuotaApi = (data) => {
  return API.post("/sponser/add-update-quota", data);
};

export const getSponsorQuotaApi = (sponsorId) => {
  return API.get(`/sponser/quota/${sponsorId}`);
};

export const removeLocationApi = (data) => {
  return API.delete("/user/remove-location", { data });
};

/* USER APIs */

export const getUsersApi = (params) => {
  return API.get("/user/list", { params });
};

export const getGuestUsersApi = (params) => {
  return API.get("/guest/user", { params });
};

export const downloadGuestUsersApi = (params) => {
  return API.get("/guest/user/download", {
    params,
    responseType: "blob",
  });
};

export const getUserInfoApi = (id) => {
  return API.get(`/user/info/`, {
    params: { id },
  });
};

export const updateUserInfoApi = (data, id) => {
  return API.put("/user/update-info", data, {
    params: { userId: id },
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const updateProfilePictureApi = (file, id) => {
  const formData = new FormData();
  formData.append("file", file);

  return API.put("/user/profile-picture", formData, {
    params: { userId: id },
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const syncUsersApi = (locationId) => {
  return API.get("/user/sync", {
    params: locationId ? { locationId } : {},
  });
};

export const getUserContactsApi = (params) => {
  return API.get("/user/v2/contacts", { params });
};

export const getUserSessionsApi = (params) => {
  return API.get("/user/session", { params });
};

export const downloadUserSessionsApi = (params) => {
  return API.get("/user/session/download", {
    params,
    responseType: "blob",
  });
};

export const downloadUserContactsApi = (params) => {
  return API.get("/user/contacts/download", {
    params,
    responseType: "blob",
  });
};

export const toggleUserStatusApi = (data) => {
  return API.put("/user/status/toggle", data);
};

export const downloadUsersApi = (params) => {
  return API.get("/user/download", {
    params,
    responseType: "blob",
  });
};
